<div class="fixed bottom-4 h-16 inset-x-0 pointer-events-none flex">
  <!--
    `w-1/2 lg:w-1/4`, NOT `w-50 lg:!w-25` (Bug #234). The old pair was BROKEN, not merely mis-named:
    `w-50` resolved to Bootstrap's `width: 50% !important` (bootstrap.min.css is loaded globally before
    styles.scss and all of its utilities are `!important`), while `lg:!w-25` matched NOTHING at all —
    Tailwind has no `w-25` utility to prefix, and Bootstrap only ships the unprefixed `.w-25`. So the toast
    was 50% wide at EVERY width and the author's "narrower on wide screens" intent never took effect.
    Restoring it is the one deliberate visual change here: at `lg+` the pill is now a quarter of the
    viewport. Safe, because it is a fixed `h-16` pill with vertically centred text, so a two-line wrap of a
    long hint still fits.
  -->
  <div class="w-1/2 lg:w-1/4 pointer-events-auto mx-auto h-16 rounded-full flex shadow-lg bg-gray-800">
    <div class="flex flex-col px-8 my-auto text-center w-full">
      <span class="mb-auto text-white">{{ message }}</span>
    </div>
  </div>
</div>
